var AdaptiveImage = require( "../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/img_background_default.f1cf82d4.png","uri@2x": __webpack_public_path__ + "static/media/img_background_default.e7ba4479.png","uri@3x": __webpack_public_path__ + "static/media/img_background_default.a2842b22.png",
    width: 375,
    height: 165
});